const s = {
  name: "HongKongDollar",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M12,14h-2v12h2v-5h2v5h2V14h-2v5h-2V14z"/>
		<path class="st0" d="M19,14h-2v12h2v-4.8l1.6,1l0,0c0.3,0.2,0.4,0.5,0.4,0.8V26h2v-2.9c0-1-0.5-1.9-1.3-2.5L20.8,20l0.9-0.6
			c0.8-0.6,1.3-1.5,1.3-2.5V14h-2v2.9c0,0.3-0.2,0.6-0.4,0.8l-1.6,1V14z"/>
		<path class="st0" d="M26,17c0-0.5,0.5-1,1-1c0.5,0,1,0.5,1,1v1h2v-1c0-1.3-0.8-2.4-2-2.8V13h-2v1.2c-1.2,0.4-2,1.5-2,2.8v0.8
			c0,1.1,0.6,2.2,1.7,2.7l1.8,0.9c0.3,0.2,0.6,0.5,0.6,0.9V23c0,0.5-0.5,1-1,1c-0.5,0-1-0.5-1-1v-1h-2v1c0,1.3,0.8,2.4,2,2.8V27h2
			v-1.2c1.2-0.4,2-1.5,2-2.8v-0.8c0-1.1-0.6-2.2-1.7-2.7l-1.8-0.9c-0.3-0.2-0.6-0.5-0.6-0.9V17z"/>
		<path class="st0" d="M20,0C9,0,0,9,0,20s9,20,20,20c11,0,20-9,20-20S31.1,0,20,0z M2,20c0-9.9,8.1-18,18-18c9.9,0,18,8.1,18,18
			s-8.1,18-18,18C10.1,38,2,29.9,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as HongKongDollar
};
